
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('circle',{staticClass:"a",attrs:{"cx":"12","cy":"12","r":"11.25"}}),_c('path',{staticClass:"a",attrs:{"d":"M4.045 19.955l15.91-15.91"}})])
          )
        }
      }
    